<template>
  <component :is="tag" :class="{ open: isOpen }" @click="$emit('click')">
    <slot name="trigger" v-bind="{ isOpen, toggle }" />
    <slot name="collapsible" v-bind="{ isOpen, toggle, close }" />
  </component>
</template>

<script>
export default {

  props: {
    tag: {
      type: String,
      default: 'div'
    },
    initialOpen: {
      type: Boolean,
      default: false,
    }
  },

  data () {
    return {
      isOpen: this.initialOpen
    }
  },

  methods: {
    toggle () {
      this.isOpen = !this.isOpen
    },

    close () {
      this.isOpen = false
    }
  }
}
</script>
